<ion-header>
    <ion-toolbar>
        <ion-title>Add Site</ion-title>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>
        <ion-input type="text" placeholder="Type customer/company name" [(ngModel)]="site.name"></ion-input>
        <ion-input type="text" placeholder="Type Address 1" [(ngModel)]="site.add1"></ion-input>
        <ion-input type="text" placeholder="Type Address 2" [(ngModel)]="site.add2"></ion-input>
        <ion-input type="text" placeholder="Type Address 3" [(ngModel)]="site.add3"></ion-input>
        <ion-input type="text" placeholder="Type Address 4" [(ngModel)]="site.add4"></ion-input>
        <ion-input type="text" placeholder="Latitude" [(ngModel)]="site.latitude"></ion-input>
        <ion-input type="text" placeholder="Longitude" [(ngModel)]="site.longitude"></ion-input>
        <ion-button expand="full" (click)="getCoordinates()" color="light">Get Coordinates
            <ion-icon slot="start" name="compass"></ion-icon>
        </ion-button>
 
            <ion-fab vertical="bottom" horizontal="end">
                <ion-fab-button (click)="saveSite()" color="success">
                    <ion-icon name="checkmark"></ion-icon>
                </ion-fab-button>
            </ion-fab>
       

    </ion-card> 

</ion-content>
